import { combineReducers } from 'redux';
import quizzes from './quiz.reducer';
import quizViewer from './quizViewer.reducer';
import quizScore from './quizScore.reducer';

const quizAppReducer = combineReducers({
    quizzes,
    quizViewer,
    quizScore,
});

export default quizAppReducer;


// WEBPACK FOOTER //
// src/main/content/quiz/store/reducers/index.js